import React from "react";

import { DesktopCloseButton } from "EmployerApplication/Components/FormSections/DesktopCloseButton";
import HarmonyIcon from "Intuit/HarmonyIcon";
import isIntuit from "Intuit/isIntuit";
import MobilePlanDetails from "QuotePage/app/MobilePlanDetails";
import { PlanDetailsDumb } from "QuotePage/app/PlanDetails";
import PlanDetailsHeader from "QuotePage/app/planDetails/Header";

import { ReduxTrigger, ReduxTriggerButton, FullScreenModal, Modal, ModalBody, ModalHeader } from "Cobalt/Modal";
import Header from "Cobalt/Header";
import Icon from "Common/Icon";
import { SizeSwitch, getWindowSize } from "Common/Responsive";

import type { MedicalPlanPrice, MedicalPlan } from "Utils/types";

import makeBem from "Utils/makeBem";

const bem = makeBem("MedicalPlanDetailsModal");
export const MoreDetailsButton = ({
  plan,
  showIcon = true,
  buttonTextOverride,
}: {
  plan: MedicalPlanPrice | MedicalPlan;
  showIcon: boolean;
  buttonTextOverride: string;
}) => {
  if (getWindowSize !== "sm") {
    return (
      <ReduxTriggerButton
        name={plan.full_display_name}
        p={0}
        ml={0}
        style={{
          verticalAlign: "top",
        }}
      >
        {showIcon && <>{isIntuit() ? <HarmonyIcon spacing="right" icon="circle-info" /> : <Icon spacing="right" icon="info-circle" flavor="solid" />}</>}
        {buttonTextOverride || "More Details"}
      </ReduxTriggerButton>
    );
  }
  return (
    <ReduxTriggerButton color="gray" className={`${isIntuit() ? "px-4" : ""}`} name={plan.full_display_name}>
      {buttonTextOverride || "View Details"}
    </ReduxTriggerButton>
  );
};
type MedicalPlanDetailsModalProps = {
  plan: MedicalPlanPrice | MedicalPlan;
  isSampleQuote: boolean;
  inCart: boolean;
  isAlternateCart: boolean;
  rest?: any;
};
export const MedicalPlanDetailsModal = ({ plan, isSampleQuote, inCart, isAlternateCart, ...rest }: MedicalPlanDetailsModalProps) => (
  <ReduxTrigger
    name={plan.full_display_name}
    modal={(props) => (
      <FullScreenModal className="more-details-modal" {...props}>
        <SizeSwitch
          xs={
            <ModalBody className={bem("MobileModalContainer")}>
              <MobilePlanDetails plan={plan} inCart={inCart} />
            </ModalBody>
          }
          md={
            <div>
              <ModalHeader key="header" closeButton={isIntuit()}>
                {!isIntuit() && <DesktopCloseButton onHide={props.onHide} />}
                <Header level={7} mb={0}>
                  <PlanDetailsHeader plan={plan} isSampleQuote={isSampleQuote} inCart={inCart} />
                </Header>
              </ModalHeader>
              <ModalBody key="body" className="py-0 more-details-modal-body">
                <PlanDetailsDumb plan={plan} inCart={inCart} isAlternateCart={isAlternateCart} {...(rest as any)} />
              </ModalBody>
            </div>
          }
        />
      </FullScreenModal>
    )}
  />
);
export default MedicalPlanDetailsModal;
